import React from "react";
import {safeImage} from "../../../../helpers/helperFunctions";

const BrandCard = ({brand, isFeatured, mobile}) => {

  return (

    isFeatured ? <FeaturedBrandCard brand={brand} mobile={mobile}/> : <AllBrandCard brand={brand} mobile={mobile}/>
  );
};

export default BrandCard;

const AllBrandCard = ({brand}) => {

  return (

    brand.images ? <img src={safeImage(brand.images)} alt={brand.name} className="brand-normal-size mr-4"/> :
      <div className="font-bold bg-red-100 mr-4 brand-normal-size">{brand.title}</div>
  );
};

const FeaturedBrandCard = ({brand}) => {

  return (

    <div className={`mr-2${brand.comment ? " shadow-md bg-white app-rounded" : ""}`}>
      <div className={`image-aspect-ratio-hr brand-featured-size bg-white app-rounded overflow-hidden${brand.comment ? "" : " shadow-md"}`}>
        <img className="object-cover image-aspect-ratio-hr brand-featured-size" alt={brand.title}
             src={safeImage(brand.images)}/>
      </div>
      {(brand.comment) &&
      <div className={`text-center leading-snug font-bold text-secondaryApp py-2`}>
        {brand.comment}
      </div>
      }
    </div>
  );
};

